import ReactGA from "react-ga";

const googleAnalyticsActions = {};

googleAnalyticsActions.initGoogleAnalytics = async (key) => {
  ReactGA.initialize("UA-215323468-1");
  ReactGA.pageview(window.location.pathname + window.location.search);
};

export { googleAnalyticsActions };
